import { FiSend } from "react-icons/fi";
import { Button } from "../common";

// [NEW] Appears above an employee table once rows are ticked.
export default function BulkSelectionBar({ count, onClear, onInvite, actionLabel = "Send invitations", actionIcon: ActionIcon = FiSend }) {
  if (!count) return null;
  return (
    <div className="bulk-bar" role="status">
      <span><strong>{count}</strong> selected</span>
      <Button size="sm" icon={ActionIcon} onClick={onInvite}>{actionLabel}</Button>
      <Button size="sm" variant="ghost" onClick={onClear}>Clear selection</Button>
    </div>
  );
}
